module.exports = __webpack_public_path__ + "static/img/Round-20-2013.f42d268.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-20-2013.jpg
// module id = 3Spo
// module chunks = 0